module.exports = __webpack_public_path__ + "static/img/243_TO8_2186.f492f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/243_TO8_2186.jpg
// module id = zhwm
// module chunks = 0